import { getHotlineOpeningHoursHeaderVersion, HotlineConfig } from 'common-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderType } from '../Header';
import { useIsMobile } from '../../utils/useIsMobile';
import ContactMenuMobile from './ContactMenuMobile';
import ContactMenuDesktop from './ContactMenuDesktop';
import { Typography } from '../../Typography/Typography';

import useStyles from './ContactMenu.style';

export interface ContactMenuProps {
  headerType: HeaderType;
}

const ContactMenu: React.FC<ContactMenuProps> = ({headerType }) => {
  const isMobile = useIsMobile();
  const isTablet = useIsMobile('md');

  if (isMobile || (isTablet && headerType === HeaderType.BeforeLogin)) {
    return <ContactMenuMobile />;
  }
  return <ContactMenuDesktop />;
};

export default ContactMenu;

export const HotlineInfo: React.FC<{hotlineConfig?: HotlineConfig}> = ({hotlineConfig}) => {
  const c = useStyles({});
  const [t] = useTranslation('header');
  const [tt] = useTranslation('translation');

  return (
    <div className={c.hotlineInfoWrapper}>
      <Typography variant="body2" className={c.hotLineTitle}>{t('contact-menu.opening-hours-title')}</Typography>
      <Typography className={c.hotLineHoursInfo}>
        {hotlineConfig && getHotlineOpeningHoursHeaderVersion(hotlineConfig, tt, c.hotLineRatesInfo)}
      </Typography>
    </div>
  );
}

export const ContactNumberText = ({ number }: { number: string}) => {
  return(
    <Typography component="span" fontWeight='extraBold' variant='subHeadline2'>
      {number}
    </Typography>
  )
};
